import React from 'react';
import PropTypes from 'prop-types';
import QrReader from 'react-qr-reader';
import _ from 'lodash';

class QrCodeScanner extends React.PureComponent {
  static propTypes = {
    onDetect: PropTypes.func,
  };

  static defaultProps = {
    onDetect: _.identity,
  };

  onError = err => console.error(err);

  render() {
    const { onDetect, className } = this.props;

    return (
      <QrReader
        className={className}
        onScan={onDetect}
        onError={this.onError}
      />
    );
  }
}

export default QrCodeScanner;



// WEBPACK FOOTER //
// ../pos-master/packages/pos-components/src/QrCodeScanner/QrCodeScanner.jsx